function NewTabs({ tablist, setActive, active, onFilter, tabIconList ,loading}: any) {
    return (
      <div className="tab-choose mt-2">
        {tablist && (
          <ul>
            {tablist?.map((a: any, i: any) => (
              <li
                key={i}
                className={`f-14 me-3 cursor-pointer ${
                  a.id === active ? "tab-active" : ""
                }`}
                onClick={() => {
                  if (!loading) {
                  setActive(a.id);
                  onFilter(a.name);
                  }
                }}
              >
                {a.name}
              </li>
            ))}
          </ul>
        )}
        {tabIconList && (
          <ul className="">
            {tabIconList?.map((a: any, i: any) => (
              // <span className="d-flex align-items-center justify-content-center">
                <li
                  key={i}
                  className={`f-14 cursor-pointer ${
                    a.id === active ? "tab-active" : ""
                  }`}
                  onClick={() => {
                    if (!loading) {
                    setActive(a.id);
                    onFilter(a.name);
                    }
                  }}
                >
                  <span className="material-symbols-outlined">{a.name}</span>
                </li>
              // </span>
            ))}
          </ul>
        )}
      </div>
    );
  }
  
  export default NewTabs;
  